import { UserInviteSuccess } from 'app/modules/user-management/user-invite/components/InviteUser/UserInviteSuccess/UserInviteSuccess';

export const UserInviteSuccessPage = (): JSX.Element => <UserInviteSuccess />;
